import { getMessages } from '../../../../../../../store/constants';
import { ECustomPropertyType } from '../../../../../../../store/customProperties/types';

export const CUSTOM_BUTTON_SAVE = getMessages().getText('common.save');
export const CUSTOM_ERROR_EMAIL = getMessages().getText('card_form_custom_error_email');
export const CUSTOM_ERROR_PHONE = getMessages().getText('card_form_custom_error_phone');

export const CUSTOM_LABEL_MAP: {[key: string]: string }  = {
    [ECustomPropertyType.EMAIL]: getMessages().getText('card_form_custom_label_email'),
    [ECustomPropertyType.PHONE]: getMessages().getText('card_form_custom_label_phone'),
    [ECustomPropertyType.NUMBER]: getMessages().getText('card_form_custom_label_default'),
    [ECustomPropertyType.TEXT]: getMessages().getText('card_form_custom_label_default'),
    [ECustomPropertyType.DATE]: getMessages().getText('card_form_custom_label_date'),
    [ECustomPropertyType.SELECT]: getMessages().getText('card_form_custom_label_select'),
};

export const CUSTOM_PROPERTY_SELECT_DEFAULT_VALUE = String(-1);
